import React, { useEffect, useMemo, useState } from 'react';

import { displayPartecipanteBadge } from '../utils';
import { CategoriaMap, CategoriaEventoMap } from '../components';
import { login_url } from '../globals'
import { usePartecipante, useLogin, useThread } from '../reducers'
import { Partecipante } from '../api/auto-types';


interface PartecipanteExtra extends Partecipante {
  problemi_creati: number
}

const sortingFactory = (func: (p: PartecipanteExtra) => number) => (p1: PartecipanteExtra, p2: PartecipanteExtra) => {
  if (!p1 || !p2) return 0;
  return func(p2) - func(p1)
}

const sortId = sortingFactory(p => p.id);
const sortAssegnati = sortingFactory(p => p.quanti_assegnati)
const sortCorretti = sortingFactory(p => p.quanti_corretti)
const sortDaFare = sortingFactory(p => p.quanti_assegnati - p.quanti_assegnati_fatti)
const sortProposti = sortingFactory(p => p.problemi_creati)


type CompareFunction = (p1: Partecipante, p2: Partecipante) => number

const ListaPartecipanti = (props: {}) => {
  const part = usePartecipante(props);
  const thread = useThread(props);
  const login = useLogin();
  const [sorting, setSorting] = useState<CompareFunction>(() => sortId);

  const partecipanti: PartecipanteExtra[] = useMemo(() => {
    const problems_pk = new Set(thread.filter(t => t.tipologia === "p").map(t => t.id));
    return part.map(p => {
      return {
        problemi_creati: p.thread_creati.filter(pk => problems_pk.has(pk)).length,
        ...p
      }
    })
  }, [part, thread]);


  useEffect(() => {
    document.title = `Partecipanti - Owlitrack`;
  }, [])
  if (!login.logged_in) {
    login_url()
  }

  return (
    <div className="container">
      <h1 className="page-header">Lista degli iscritti a Owlitrack</h1>
      <div className="table-responsive">
        <table className="table table-bordered table-hover table-striped">
          <thead className="thead-dark">
            <tr>
              <th
                onClick={() => setSorting(() => sortId)}
              ><i className="fa fa-sort" /> Id</th>
              <th>Nome</th>
              <th title="Eventi assegnati (ha senso solo se i permessi sono del tipo 'evento')">Eventi</th>
              <th title="Numero di problemi assegnati da correggere"
                onClick={() => setSorting(() => sortAssegnati)}
              ><i className="fa fa-sort" /> Assegnati</th>
              <th title="Numero di problemi corretti"
                onClick={() => setSorting(() => sortCorretti)}
              ><i className="fa fa-sort" /> Risolti</th>
              <th title="Numero di problemi assegnati da correggere non ancora fatti"
                onClick={() => setSorting(() => sortDaFare)}
              ><i className="fa fa-sort" /> Da fare</th>
              <th title="Numero di problemi proposti (visibili a te)"
                onClick={() => setSorting(() => sortProposti)}
              ><i className="fa fa-sort" /> Proposti</th>
              <th title="Preferenze">Categorie</th>
            </tr>
          </thead>
          <tbody>
            {partecipanti.sort(sorting).map(item => {
              return (
                <tr key={item.id}>
                  <td>{item.id}</td>
                  <td>{displayPartecipanteBadge(item)}</td>
                  <td><CategoriaEventoMap cats={item.eventi_assegnati} /></td>
                  <td>{item.quanti_assegnati}</td>
                  <td>{item.quanti_corretti}</td>
                  <td>{item.quanti_assegnati - item.quanti_assegnati_fatti}</td>
                  <td>{item.problemi_creati}</td>
                  <td><CategoriaMap categorie={item.categorie_preferite} /></td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default ListaPartecipanti;
